import { render, staticRenderFns } from "./checkbox-group.vue?vue&type=template&id=1b99fea2&scoped=true"
import script from "./checkbox-group.vue?vue&type=script&setup=true&lang=js"
export * from "./checkbox-group.vue?vue&type=script&setup=true&lang=js"
import style0 from "./checkbox-group.vue?vue&type=style&index=0&id=1b99fea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b99fea2",
  null
  
)

export default component.exports